var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-form",
    { attrs: { inline: "" } },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("invoice-disputes.dispute_code"),
            size: "mini"
          }
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                value: _vm.filterDisputeCodes,
                multiple: "",
                "collapse-tags": "",
                placeholder: _vm.$t("invoice-disputes.dispute_code")
              },
              on: { change: _vm.handleDisputeCodesFilterChange }
            },
            _vm._l(_vm.sortedDisputeCodes, function(disputeCode) {
              return _c("el-option", {
                key: disputeCode.code,
                attrs: {
                  label: _vm.$translate.dispute_code(disputeCode.code),
                  value: disputeCode.code
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { size: "mini" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: _vm.filterDue ? "primary" : undefined },
              on: { click: _vm.handleShowUrgentClick }
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("invoice-disputes.show_urgent_tasks")) +
                  "\n\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: { label: _vm.$t("invoice-disputes.assigned_to"), size: "mini" }
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                value: _vm.filterAssignee,
                placeholder: _vm.$t("invoice-disputes.assigned_to")
              },
              on: { change: _vm.handleAssigneeFilterChange }
            },
            [
              _c("el-option", {
                key: "all",
                attrs: { label: _vm.$t("invoice-disputes.all"), value: "all" }
              }),
              _vm._v(" "),
              _c("el-option", {
                key: "unassigned",
                attrs: {
                  label: _vm.$t("invoice-disputes.unassigned"),
                  value: "unassigned"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.participantUsers, function(user) {
                return _c("el-option", {
                  key: user.person_by_reference.reference,
                  attrs: {
                    label: user.person_by_reference.username,
                    value: user.person_by_reference.reference
                  }
                })
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { size: "mini" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                type:
                  _vm.filterAssignee ===
                  _vm.$store.state.risolto.loggedInUser.reference
                    ? "primary"
                    : undefined
              },
              on: { click: _vm.handleAssignedToMeClick }
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("invoice-disputes.assigned_to_me")) +
                  "\n\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { size: "mini" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("applyFilters")) + "\n\t\t")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }